import { useFormState } from '../../../../../bookings/FormState/useFormState';
import { LinkId } from '../../../../AnalyticsContext/LinkId';
import { useCorporateGroupIdentityConfig } from '../../../../CorporateGroupIdentityConfigProvider/CorporateGroupIdentityConfigProvider';
import { IdentityProvider } from '../../../../UserProvider/UserData';
import { useUserData } from '../../../../UserProvider/UserProvider';
import { LoginMethod, useLogin } from '../../../../UserProvider/useLogin';
import { useCTA } from '../../../../hooks/useCTA';
import { CTADot } from '../../../CTADot';
import { IdentityProviderLoginGroup } from './IdentityProviderLoginGroup/IdentityProviderLoginGroup';
import {
  ActionBar,
  Close,
  Greeting,
  StyledLink,
  JumbotronView,
  Login,
  Welcome,
} from './Jumbotron.styles';

interface Props {
  onSelect?: VoidFunction;
  showExternalActions: boolean;
  showLoginsAndPolicyPopups: boolean;
}

export const Jumbotron = ({ onSelect, showExternalActions, showLoginsAndPolicyPopups }: Props) => {
  const { data: user, loading: userLoading, identityProvider } = useUserData();

  const {
    state: {
      appointment: { bookingFormClient, practice },
    },
  } = useFormState();

  const practiceId = practice?.id;
  const triggerLogin = useLogin(LoginMethod.Email, { practiceId, bookingFormClient });

  const { data: identityConfig } = useCorporateGroupIdentityConfig();
  const { cta } = useCTA();

  return (
    <JumbotronView loggedIn={!!user}>
      <ActionBar>
        <Close onClick={onSelect} />
      </ActionBar>

      <Greeting data-testid="mobileMenuFirstName">
        Hi{user && user.firstName && ` ${user.firstName}`}
        {identityProvider === IdentityProvider.HEALTHENGINE && showExternalActions && ','}
      </Greeting>

      {identityProvider === IdentityProvider.HEALTHENGINE && user && (
        <>
          <StyledLink
            onClick={onSelect}
            to="/my-account/profiles"
            trackingId={LinkId.MOBILE_MENU_ACCOUNT}
          >
            Account
          </StyledLink>

          <StyledLink
            onClick={onSelect}
            to="/my-account/bookings/"
            trackingId={LinkId.MOBILE_MENU_BOOKINGS}
          >
            Bookings
          </StyledLink>

          <StyledLink
            onClick={onSelect}
            to="/my-account/favourites/"
            trackingId={LinkId.MOBILE_MENU_MY_CARE_TEAM}
          >
            My Care Team™
            {cta?.showMctCTA && <CTADot />}
          </StyledLink>

          <StyledLink
            onClick={onSelect}
            to="/my-account/health-interests/"
            trackingId={LinkId.MOBILE_MENU_HEALTH_INTERESTS}
          >
            Health interests
            {cta?.showHealthInterestsCTA && <CTADot />}
          </StyledLink>

          <StyledLink
            onClick={onSelect}
            to="/my-account/offers/"
            trackingId={LinkId.MOBILE_MENU_OFFERS}
          >
            Offers
            {cta?.showNewOfferAddedCTA && <CTADot />}
          </StyledLink>
          <StyledLink
            onClick={onSelect}
            to="/my-account/data-privacy"
            trackingId={LinkId.MOBILE_MENU_DATA_AND_PRIVACY}
          >
            Data & privacy
            {cta?.showPrivacyPreferencesCTA && <CTADot />}
          </StyledLink>
        </>
      )}
      {identityProvider === IdentityProvider.HEALTHENGINE && !userLoading && !user && (
        <>
          {showExternalActions && <Welcome>Welcome to Healthengine</Welcome>}
          {showLoginsAndPolicyPopups && (
            <Login onClick={triggerLogin} trackingId={LinkId.MOBILE_LOGIN_SIGNUP}>
              Log in or Sign up
            </Login>
          )}
        </>
      )}
      {identityProvider === IdentityProvider.CORPORATE_GROUP &&
        !userLoading &&
        !user &&
        identityConfig && <IdentityProviderLoginGroup config={identityConfig} />}
    </JumbotronView>
  );
};
